import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';

import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import useMobileLayout from 'Hooks/useMobileLayout';
import AccountSetupSection from '../../Components/AccountSetup/AccountSetupSection';
import SurveyFixedFooterActions from '../../../SurveyFixedFooterActions';
import { useSurveyStepContext } from '../../SurveyStepContext';

const styles = (theme) => ({
  root: {},
  footer: {},
  enableButton: {
    marginTop: theme.spacing(1),
  },
});

const AccountSetupRememberThisDeviceLayout = ({
  classes,
}) => {
  const {
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  const {
    onClickNext,
    goToNextStep,
  } = useSurveyStepContext();
  const isMobile = useMobileLayout();

  return (
    <div className={classes.root}>
      {/* ---------- Section title / icon / message ---------- */}
      <AccountSetupSection
        title={'Remember this device'}
        messages={[
          'If enabled, you won\'t be required to enter a multi-factor verification code when logging in from this device for the next few weeks. You will still be required to log in with your username and password (so remember that password!).',
          'We do not recommend enabling this setting on a shared device, such as a library computer.',
        ]}
        showFacetIcon
      />

      {/* ---------- Footer (Remember this device / Don't) ---------- */}
      <SurveyFixedFooterActions>
        <TextButton
          onClick={goToNextStep}
          color={'primary'}
          weight={'bold'}
          fullWidth
          size={!isMobile ? 'lg' : 'md'}
          test={'do-not-remember-this-device-button'}
        >
          {'Don\'t remember this device'}
        </TextButton>
        <RoundedButton
          className={classes.enableButton}
          onClick={() => onClickNext(onSubmitMetaForm)}
          color={'primary'}
          variant={'contained'}
          disableElevation
          fullWidth
          test={'remember-this-device-button'}
        >
          {'Remember this device'}
        </RoundedButton>
      </SurveyFixedFooterActions>
    </div>
  );
};

AccountSetupRememberThisDeviceLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

AccountSetupRememberThisDeviceLayout.defaultProps = {
};

export default withStyles(styles)(AccountSetupRememberThisDeviceLayout);
